import React, { Component } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { AppCard } from "../../../components/ui";
import { issuingApiService } from "../../../services/api/Issuing/IssuingApiService";
import ImportedFilesTable from "./importedFilesTable";
import SettlementCutOffsTable from "./settlementCutOffsTable";
import DateFilterBar from "../../../components/DateFilterBar";

interface ReportingState {
    activeIndex: number;
    fromDate: Date | null;
    toDate: Date | null;
    appliedFromDate: Date | null;
    appliedToDate: Date | null;
}

export default class ReportingMainComponent extends Component<any, ReportingState> {
    constructor(props: any) {
        super(props);
        const today = new Date();
        const last3Months = new Date();
        last3Months.setMonth(today.getMonth() - 3);

        this.state = {
            activeIndex: 0,
            fromDate: last3Months,
            toDate: today,
            appliedFromDate: last3Months,
            appliedToDate: today,
        };
    }

    render() {
        const { fromDate, toDate, appliedFromDate, appliedToDate, activeIndex } = this.state;

        return (
            <>
                    <div className="px-5 pt-4 pb-2 border-b border-neutral-100 dark:border-neutral-800">
                        <DateFilterBar
                            fromDate={fromDate}
                            toDate={toDate}
                            maxDate={new Date()}
                            onChangeFrom={(date) => this.setState({ fromDate: date })}
                            onChangeTo={(date) => this.setState({ toDate: date })}
                            onApply={() =>
                                this.setState({
                                    appliedFromDate: fromDate,
                                    appliedToDate: toDate,
                                })
                            }
                            onClear={() =>
                                this.setState({
                                    fromDate: null,
                                    toDate: null,
                                    appliedFromDate: null,
                                    appliedToDate: null,
                                })
                            }
                        />
                    </div>
                     <AppCard>
                        <AppCard.Body className="!p-0">
                            <TabView
                                activeIndex={activeIndex}
                                onTabChange={(e) => this.setState({ activeIndex: e.index })}
                            >
                                <TabPanel header="Imported Files"
                                    pt={{ content: { className: "pt-0 px-5 pb-5" } }}

                                >
                                    <ImportedFilesTable
                                        key={`${appliedFromDate}-${appliedToDate}`}
                                        loadApi={issuingApiService.getImportedFiles}
                                        detailsRoute="/issuing/file-details"
                                        from={appliedFromDate?.toISOString() ?? ""}
                                        to={appliedToDate?.toISOString() ?? ""}
                                    />
                                </TabPanel>
                                <TabPanel header="Settlement Cut-Offs" pt={{ content: { className: "pt-0 px-5 pb-5" } }}
                                >
                                    <SettlementCutOffsTable
                                        key={`${appliedFromDate}-${appliedToDate}`}
                                        loadApi={issuingApiService.getSettlementCutOffsFiles}
                                        detailsRoute="/issuing/file-details"
                                        from={appliedFromDate?.toISOString().split("T")[0] ?? ""}
                                        to={appliedToDate?.toISOString().split("T")[0] ?? ""}
                                    />
                                </TabPanel>
                            </TabView>
                        </AppCard.Body>
                    </AppCard>
                    </>
                   
              
        );
    }
}
